import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSessionId } from "../../../../../../utils/tokenHandlers";
import { getLocalBank } from "../../apis/getLocalBank";

export const getLocalBankAction = createAsyncThunk(
  "getLocalBankAction",
  async (bankId: number) => {
    return getLocalBank(bankId, getSessionId()).then((response: any) => {
      return response.data;
    });
  }
);
